import { useCallback, useState } from 'react'

export default function useConnectorSelection() {
  const [highlightedInvoiceRowIds, setHighlightedInvoiceRowIds] = useState<
    Set<string>
  >(new Set())
  const [highlightedPoRowIds, setHighlightedPoRowIds] = useState<Set<string>>(
    new Set(),
  )

  const handleConnectorSelectionChange = useCallback(
    (selection: { invoiceRowId: string; poRowIds: string[] } | null) => {
      if (selection) {
        setHighlightedInvoiceRowIds(new Set([selection.invoiceRowId]))
        setHighlightedPoRowIds(new Set(selection.poRowIds))
      } else {
        setHighlightedInvoiceRowIds(new Set())
        setHighlightedPoRowIds(new Set())
      }
    },
    [],
  )

  return {
    highlightedInvoiceRowIds,
    highlightedPoRowIds,
    handleConnectorSelectionChange,
  }
}
